module.exports = __webpack_public_path__ + "img/logout.56510172.svg";